import { get } from 'lodash/fp';

import hasHospitalComponent from '../../../../utils/has-hospital-component';

// @ts-expect-error - Automatic, Please fix when editing this file
const getIsProductUnavailable = ({ product, customerExcess }) => {
  const productExcess = get('charges.excess.amount')(product);
  return hasHospitalComponent(product) && customerExcess !== productExcess;
};

export default getIsProductUnavailable;
